import React, { Suspense, lazy } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";

// Elements
import BackToTop from "./elements/back-top";
import PageScrollTop from "./elements/page-scroll-top";

// Layout
import Header from "./layout/header";
import Footer from "./layout/footer";

// Route-level code splitting — every page loads on demand
const Index = lazy(() => import("./pages/index"));
const AboutUs = lazy(() => import("./pages/about-us"));
const ContactUs = lazy(() => import("./pages/contact-us"));
const BlogDetails = lazy(() => import("./pages/blog-details"));
const Error404 = lazy(() => import("./pages/error-404"));
const Distribution = lazy(() => import("./pages/distribution"));
const Blogs = lazy(() => import("./pages/Blogs"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("./pages/TermsOfUse"));
const Medicine = lazy(() => import("./pages/Medicine"));
const MedicineDetail = lazy(() => import("./pages/MedicineDetail"));
const Quality = lazy(() => import("./pages/Quality"));
const TherapeuticAreas = lazy(() => import("./pages/TherapeuticAreas"));
const BecomeDistributor = lazy(() => import("./pages/BecomeDistributor"));
const FAQ = lazy(() => import("./pages/FAQ"));

const RouteFallback = () => (
  <div
    style={{
      minHeight: "60vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "var(--brand-primary)",
    }}
    aria-live="polite"
    aria-busy="true"
  >
    Loading…
  </div>
);

const ThemeLayout = () => (
  <>
    <Header />
    <main id="main-content">
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
    </main>
    <Footer />
  </>
);

const Markup = () => (
  <>
    <BrowserRouter>
      <Routes>
        <Route element={<ThemeLayout />}>
          <Route path="/" element={<Index />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/:slug" element={<BlogDetails />} />
          <Route path="/distribution" element={<Distribution />} />
          <Route path="/become-a-distributor" element={<BecomeDistributor />} />
          <Route path="/quality" element={<Quality />} />
          <Route path="/therapeutic-areas" element={<TherapeuticAreas />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          {/* Legacy path — kept indefinitely for backlink SEO */}
          <Route
            path="/term-of-use"
            element={<Navigate to="/terms-of-use" replace />}
          />
          <Route path="/medicine" element={<Medicine />} />
          <Route path="/medicine/:slug" element={<MedicineDetail />} />
          <Route path="*" element={<Error404 />} />
        </Route>
      </Routes>
      <PageScrollTop />
    </BrowserRouter>
    <BackToTop />
  </>
);

export default Markup;
